module.exports = __webpack_public_path__ + "05_hige_black.2d306664.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer3/05_hige_black.png
// module id = pQHx
// module chunks = 0